import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import Image, { ImageProps } from '~/components/UI/Image'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface ProductInfoProps {
  images?: ImageProps[]
  name?: string
  subtitle?: string
}

function ProductInfo({ images, name, subtitle }: ProductInfoProps) {
  const nameStyle = useStyle({
    textPreset: GlobalTextPreset.Title12Haffer,
    color: GlobalThemeColors.Black,
    textStyling: GlobalTextStyling.UpperCase,
  })

  const subtitleStyle = useStyle({
    textPreset: GlobalTextPreset.Label11_12Haffer,
    color: GlobalThemeColors.DoveGray,
    textStyling: GlobalTextStyling.UpperCase,
  })

  if (!images || !name || !subtitle) return null

  return (
    <div className={css.ProductInfo}>
      {images && (
        <div className={css.mainImage}>
          <Image
            className={css.mainImage}
            layout="fill"
            objectFit="cover"
            ratio={css.ratio}
            asPlaceholder
            priority={true}
            {...images[0]}
          />
        </div>
      )}
      {name ||
        (subtitle && (
          <div className={css.texts}>
            {name && (
              <h2 className={cx(css.nameStickyStyle, nameStyle)}>{name}</h2>
            )}
            {subtitle && (
              <h2 className={cx(css.subtitleStyle, subtitleStyle)}>
                {subtitle}
              </h2>
            )}
          </div>
        ))}
    </div>
  )
}

export default ProductInfo
